
import { ILineChartData, IGenreType, IEntityType, IDimension } from "../../typings";
import { getCountryFlag } from "@/pages/home/_config/countries";
import { getPlatformList } from "../../utils";
import { getDetailGamePathCommon, getCompanyDetailsPath } from '@/pages/intelligence/utils/topchartsUtils';
import moment from 'moment';

interface ITableFormatterProp {
  list: IFetchDataItemWhenNotOpera[];
  metricMap: any;
  keyMap: any;
  genreType: IGenreType;
  genreName: string;
  entityType: IEntityType;
}
interface IFetchDataMetricHistroyItem {
  date: string;
  value: number;
}
interface IFetchDataMetricItem {
  metric: string;
  history: IFetchDataMetricHistroyItem[];
}

interface IFetchDataItemWhenNotOpera {
  id: string;
  name: string;
  cover: string;
  markets: string;
  metrics: IFetchDataMetricItem[],
  [key: string]: any;
}

interface IFetchDataItemWhenOpera {
  date: string;
  [key: string]: any;
}

interface ITableFormatterWhenOperaProp {
  list: IFetchDataItemWhenNotOpera[];
  keyMap: any;
  metricMap: any;
  isCn: boolean;
  locale: Function;
  timeType: 'monthly'|'weekly'|'daily';
}

export const METRIC_KEY_MAP:any = {
  marketType: 'entity_type',
  dimension: 'data_tag',
  rangeTime: {
    startDate: 'start_date',
    endDate: 'end_date',
    granularity: 'granularity',
  },
  region: 'regions',
  sortOrder: 'order',
  sortKey: 'order_by',
  pageIndex: '',
  pageSize: 'page_size',
  selectedList: 'select_code'
};

export const PAGE_LOG_CONFIG_KEYS: any = {
  ['mobile_operation']: 'genreProfileDetailStatsMobileGameMarketOperationData',
  ['mobile_games']: 'genreProfileDetailStatsMobileGameMarketByGames',
  ['mobile_countries']: 'genreProfileDetailStatsMobileGameMarketByCountries',
  ['mobile_companies']: 'genreProfileDetailStatsMobileGameMarketByCompanies',
  ['pc_operation']: 'genreProfileDetailStatsPCGameMarketOperationData',
  ['pc_games']: 'genreProfileDetailStatsPCGameMarketByGames',
  ['pc_countries']: 'genreProfileDetailStatsPCGameMarketByCountries',
  ['pc_companies']: 'genreProfileDetailStatsPCGameMarketByCompanies',
  ['console_operation']: 'genreProfileDetailStatsConsoleGameMarketOperationData',
  ['console_games']: 'genreProfileDetailStatsConsoleGameMarketByGames',
  ['console_countries']: 'genreProfileDetailStatsConsoleGameMarketByCountries',
  ['console_companies']: 'genreProfileDetailStatsConsoleGameMarketByCompanies',
};

export const MARKET_DIMENSION_CONFIG: any = {
  common: {
    keyMap: {
      id: 'id',
      gametitle: 'name',
      gametitleCn: 'name_cn',
      metricList: 'metrics',
      abbr: 'markets',
      cover: 'cover',
      publisher: 'publisher',
      countryIcon: 'country_img',
      platform: 'platform',
      imgType: 'imgType',
      textBubble: 'big_riser_tips',
      // 右键跳转用
      linkUrl: 'linkUrl',
      metricTitle: 'title',
      metricSource: 'source',
      metricName: 'metric',
      metricRatio: 'dod',
      metricHistory: 'history',
      metricValue: 'value'
    },
    getLinkUrl: (_dimen: IDimension, _entityType: IEntityType, params) => {
      const { id, name, name_abbr } = params;
      switch (_dimen) {
        case 'games':
          return getDetailGamePathCommon({
            entityType: _entityType,
            gameId: id,
            tab: 'overview',
          });
        case 'countries':
          const getTargetPageId = (_type: IEntityType) => {
            // total和mobile的pageid都是mobile
            let str = 'Mobile'
            switch (_type) {
              case 'pc':
                str = 'PC';
                break;
              case 'console':
                str = 'Console';
                break;
              default:
                break;
            }
            return `MarketProfil${str}`
          };
          if (name && name?.toLowerCase()?.includes('global')) return '';
          return `/intelligence/marketProfile/Overview/detail?marketName=${name}&marketNameEn=${name_abbr}&pageId=${getTargetPageId(_entityType || 'mobile')}`;
        case 'companies':
          return getCompanyDetailsPath({
            companyId: id,
            tab: 'Summary',
          });
        default:
          return ''
      };
    },
    tableDataFormatter: ({ list, metricMap, keyMap, entityType, dimen }: ITableFormatterProp) => {
      return list?.map((item, index) => ({
          ...item,
          country_img: getCountryFlag(item[keyMap.abbr]),
          rank: index,
          //feat: stats/consolegame排序时报错展示nodata
          platform: entityType === 'console' && item[keyMap.platform]?.length ? getPlatformList(item[keyMap.platform]) : null,
          imgType: entityType,
          metrics: item[keyMap.metricList]?.map((metricItem: any) => ({
            ...metricItem,
            title: metricMap?.find((mapItem: any) => mapItem.metric === metricItem.metric)?.[keyMap.metricTitle] || ''
          })),
          linkUrl: _that.common.getLinkUrl(dimen, entityType, {
            id: item[keyMap.id],
            name: item[keyMap.gametitle],
            name_abbr: item[keyMap.abbr]
          }),
      }))
    },
    lineChartDataFormatter: ({list = [], keyMap, metricMap, isCn, timeType}: ITableFormatterWhenOperaProp): ILineChartData[] => {
      const _obj: any = {};
      metricMap?.forEach((metricItem: any) => {
        _obj[metricItem.key] = [];
      })
      list?.forEach((item) => {
        const id = item?.[keyMap.id];
        const nameEn = item?.[keyMap.gametitle];
        const nameCn = item?.[keyMap.gametitleCn] || item?.[keyMap.gametitle];
        const name = isCn ? nameCn : nameEn;
        const cover = item?.[keyMap.cover];
        const metrics = item?.[keyMap.metricList];
        metrics?.forEach((metricItem: any) => {
          const metric = metricItem?.[keyMap.metricName];
          const history = metricItem?.[keyMap.metricHistory];
          // 通过前端限制折线图的数量
          if (_obj.hasOwnProperty(metric)) {
            _obj[metric].push({
              id: id,
              name: name,
              nameEn: nameEn,
              nameCn: nameCn,
              history: history?.map((_h: any) => ({
                time: moment(_h.date).format(timeType === 'monthly' ? 'YYYY-MM' : 'YYYY-MM-DD'),
                value: _h.value
              })),
              cover: cover,
            })
          }
        })
      })
      return _obj;
    },
    lineChartDataFormatterWhenOpera: ({list = [], keyMap, metricMap, localeFn, timeType}: ITableFormatterWhenOperaProp) => {
      const _arr = metricMap[0].children?.map((metricItem: any, index: number) => {
        const { label, key } = metricItem;
        return {
          id: `${key}_${index}`,
          name: localeFn({ id: label }),
          nameKey: label,
          history: list?.map((item) => {
            const name = item?.[keyMap.gametitle];
            const metrics = item?.[keyMap.metricList];
            const findMetric = metrics?.find((metricItem: any) => metricItem?.[keyMap.metricName] === key)
            return {
              time: moment(name).format(timeType === 'monthly' ? 'YYYY-MM' : 'YYYY-MM-DD'),
              value: findMetric?.[keyMap.metricValue]
            }
          }),
          cover: '',
        }
      });
      return {
        revenue: _arr
      };
    },
  },
  mobile: {
    title: {
      operation: 'dbi_genre_profile_trend',
      games: 'dbi_genre_profile_top_games',
      countries: 'dbi_genre_profile_top_countries',
      companies: 'dbi_genre_profile_top_companies'
    },
    // 用于展示折线图顶部的segment切换，还有多折线图的key
    lineTotalText: {
      operation: [{
        label: 'dbi_company_metrics_sum_revenue',
        key: 'sum_revenue'
      }, {
        label: 'dbi_calc_metric_sum_downloads',
        key: 'sum_download'
      }]
    },
    lineMetricList: {
      operation: [{
        label: 'Revenue($)',
        key: 'revenue',
        children: [{
          label: 'dbi_revenue_$',
          labelCn: '收入（美元）',
          key: 'revenue'
        }, {
          label: 'dbi_downloads',
          labelCn: '下载',
          key: 'downloads'
        }]
      }],
      games: [{
        label: 'dbi_revenue_$',
        key: 'annie_revenue'
      }, {
        label: 'dbi_downloads',
        key: 'annie_download'
      }, {
        label: 'dbi_mau',
        key: 'annie_mau',
        // 隐藏的条件,多个条件以;分割
        hideCond: 'dau,wau',
      }, {
        label: 'dbi_dau',
        key: 'annie_dau',
        // 隐藏的条件,多个条件以;分割
        hideCond: 'mau,wau',
      }, {
        label: 'dbi_wau',
        key: 'annie_wau',
        // 隐藏的条件,多个条件以;分割
        hideCond: 'mau,dau',
      }],
      countries: [{
        label: 'dbi_revenue_$',
        key: 'annie_revenue'
      }, {
        label: 'dbi_downloads',
        key: 'annie_download'
      }],
      companies: [{
        label: 'dbi_revenue_$',
        key: 'annie_revenue'
      }, {
        label: 'dbi_downloads',
        key: 'annie_download'
      }],
    },
    tableMetricList: {
      operation: [{
        title: 'dbi_revenue_$',
        source: 'appannie',
        metric: 'revenue',
        align: 'center',
        childWidth: 200,
        childAlign: 'right',
        isNeedSort: true,
      }, {
        title: 'dbi_downloads',
        source: 'appannie',
        metric: 'downloads',
        align: 'center',
        childWidth: 190,
        childAlign: 'right',
        isNeedSort: true,
      }],
      games: [{
        title: 'dbi_revenue_$',
        source: 'appannie',
        metric: 'annie_revenue',
        align: 'center',
        childWidth: 200,
        childAlign: 'right',
        isNeedSort: true,
      }, {
        title: 'dbi_revenue_$',
        source: 'sensortower',
        metric: 'sensor_revenue',
        align: 'center',
        childWidth: 200,
        childAlign: 'right',
        isNeedSort: true,
      }, {
        title: 'dbi_downloads',
        source: 'appannie',
        metric: 'annie_download',
        align: 'center',
        childWidth: 190,
        childAlign: 'right',
        isNeedSort: true,
      }, {
        title: 'dbi_downloads',
        source: 'sensortower',
        metric: 'sensor_download',
        align: 'center',
        childWidth: 190,
        childAlign: 'right',
        isNeedSort: true,
      }, {
        title: 'dbi_calc_metric_avg_mau',
        source: 'appannie',
        metric: 'annie_mau',
        align: 'center',
        childWidth: 190,
        childAlign: 'right',
        isNeedSort: true,
        // 隐藏的条件,多个条件以;分割
        hideCond: 'dau,wau',
      }, {
        title: 'dbi_calc_metric_avg_dau',
        source: 'appannie',
        metric: 'annie_dau',
        align: 'center',
        childWidth: 190,
        childAlign: 'right',
        isNeedSort: true,
        // 隐藏的条件,多个条件以;分割
        hideCond: 'mau,wau',
      }, {
        title: 'dbi_calc_metric_avg_wau',
        source: 'appannie',
        metric: 'annie_wau',
        align: 'center',
        childWidth: 190,
        childAlign: 'right',
        isNeedSort: true,
        // 隐藏的条件,多个条件以;分割
        hideCond: 'mau,dau',
      }, {
        title: 'dbi_calc_metric_avg_mau',
        source: 'sensortower',
        metric: 'sensor_mau',
        align: 'center',
        childWidth: 190,
        childAlign: 'right',
        isNeedSort: true,
        // 隐藏的条件,多个条件以;分割
        hideCond: 'dau,wau',
      }, {
        title: 'dbi_calc_metric_avg_dau',
        source: 'appannie',
        metric: 'sensor_dau',
        align: 'center',
        childWidth: 190,
        childAlign: 'right',
        isNeedSort: true,
        // 隐藏的条件,多个条件以;分割
        hideCond: 'mau,wau',
      }, {
        title: 'dbi_calc_metric_avg_wau',
        source: 'appannie',
        metric: 'sensor_wau',
        align: 'center',
        childWidth: 190,
        childAlign: 'right',
        isNeedSort: true,
        // 隐藏的条件,多个条件以;分割
        hideCond: 'mau,dau',
      }],
      countries: [{
        title: 'dbi_revenue_$',
        source: 'appannie',
        metric: 'annie_revenue',
        align: 'center',
        childWidth: 200,
        childAlign: 'right',
        isNeedSort: true,
      }, {
        title: 'dbi_downloads',
        source: 'appannie',
        metric: 'annie_download',
        align: 'center',
        childWidth: 190,
        childAlign: 'right',
        isNeedSort: true,
      }],
      companies:[{
        title: 'dbi_revenue_$',
        source: 'appannie',
        metric: 'annie_revenue',
        align: 'center',
        childWidth: 200,
        childAlign: 'right',
        isNeedSort: true,
      }, {
        title: 'dbi_downloads',
        source: 'appannie',
        metric: 'annie_download',
        align: 'center',
        childWidth: 190,
        childAlign: 'right',
        isNeedSort: true,
      }],
    },
    firstCol: {
      operation: [{
        title: 'dbi_date',
        type: 'date',
        key: 'gametitle',
        hasSort: true,
        defaultSort: true,
        hasCheckbox: false,
        hasRank: false,
        canBeClick: false
      }],
      games: [{
        title: 'dbi_games',
        type: 'gameInfo',
        key: 'gametitle',
        hasSort: false,
        defaultSort: false,
        hasCheckbox: true,
        hasRank: true,
        canBeClick: true,
        width: 360
      }],
      countries: [{
        title: 'dbi_countries',
        type: 'region',
        key: 'gametitle',
        hasSort: false,
        defaultSort: false,
        hasCheckbox: true,
        hasRank: false,
        canBeClick: true
      }],
      companies: [{
        title: 'dbi_company_companies',
        type: 'company',
        key: 'gametitle',
        hasSort: false,
        defaultSort: false,
        hasCheckbox: true,
        hasRank: true,
        canBeClick: true
      }]
    },
    specialCol: {
      operation: null,
      games: [{
        type: 'text',
        title: 'dbi_main_genre',
        key: 'genre',
        width: 180,
        align: 'center',
        childWidth: 140,
        childAlign: 'left',
      }, {
        type: 'text',
        title: 'dbi_sub_genre',
        key: 'sub_genre',
        align: 'center',
        childWidth: 220,
        childAlign: 'left',
      }, {
        type: 'action',
        title: 'dbi_actions',
        key: 'dbi_details',
        linkUrl: '',
        width: 140,
        align: 'center',
        childWidth: 100,
        childAlign: 'left',
      }],
      countries: [{
        type: 'action',
        title: 'dbi_actions',
        key: 'dbi_details',
        linkUrl: '',
        align: 'center',
        childWidth: 100,
        childAlign: 'left',
      }],
      companies: [{
        type: 'action',
        title: 'dbi_actions',
        key: 'dbi_details',
        linkUrl: '',
        align: 'center',
        childWidth: 100,
        childAlign: 'left',
      }]
    },
    tableFormatter: {
      operation: (params: ITableFormatterProp) => _that.common.tableDataFormatter(params),
      games: (params: ITableFormatterProp) => _that.common.tableDataFormatter(params),
      countries: (params: ITableFormatterProp) => _that.common.tableDataFormatter(params),
      companies: (params: ITableFormatterProp) => _that.common.tableDataFormatter(params),
    },
    lineFormatter: {
      operation: (params: ITableFormatterWhenOperaProp) => _that.common.lineChartDataFormatterWhenOpera(params),
      games: (params: ITableFormatterWhenOperaProp) => _that.common.lineChartDataFormatter(params),
      countries: (params: ITableFormatterWhenOperaProp) => _that.common.lineChartDataFormatter(params),
      companies: (params: ITableFormatterWhenOperaProp) => _that.common.lineChartDataFormatter(params),
    },
    keyMap: {
      operation: () => _that.common.keyMap,
      games: () => _that.common.keyMap,
      countries: () => Object.assign({}, _that.common.keyMap, {
        abbr: 'name_abbr'
      }),
      companies: () => _that.common.keyMap,
    }
  }, 
  pc: {
    title: {
      operation: 'dbi_genre_profile_trend',
      games: 'dbi_genre_profile_top_games',
      countries: 'dbi_genre_profile_top_countries',
      companies: 'dbi_genre_profile_top_companies'
    },
    lineTotalText: {
      operation: [{
        label: 'dbi_company_metrics_sum_revenue',
        key: 'sum_revenue'
      }]
    },
    lineMetricList: {
      // 组件设定是多个segment去切换多个折线图，这里只有一个折线图，依旧要以数组形式
      operation: [{
        label: 'Revenue($)',
        key: 'revenue',
        // 折线图包含几条线，operation维度和其他不一样。
        children: [{
          label: 'dbi_metric_digitalRevenue',
          key: 'digital_revenue'
        }, {
          label: 'dbi_metric_physical_revenue',
          key: 'physical_revenue'
        }]
      }],
      games: [{
        label: 'dbi_metric_digitalRevenue',
        key: 'digital_revenue'
      }, {
        label: 'dbi_metric_physical_revenue',
        key: 'physical_revenue'
      }, {
        label: 'dbi_metric_mau',
        key: 'mau',
        // 隐藏的条件,多个条件以;分割
        hideCond: 'dau,wau',
      }, {
        label: 'dbi_metric_dau',
        key: 'dau',
        // 隐藏的条件,多个条件以;分割
        hideCond: 'mau,wau',
      }, {
        label: 'dbi_metric_wau',
        key: 'wau',
        // 隐藏的条件,多个条件以;分割
        hideCond: 'mau,dau',
      }],
      countries: [{
        label: 'dbi_metric_digitalRevenue',
        key: 'digital_revenue'
      }, {
        label: 'dbi_metric_physical_revenue',
        key: 'physical_revenue'
      }],
      companies: [{
        label: 'dbi_metric_digitalRevenue',
        key: 'digital_revenue'
      }, {
        label: 'dbi_metric_physical_revenue',
        key: 'physical_revenue'
      }],
    },
    tableMetricList: {
      operation: [{
        title: 'dbi_metric_digitalRevenue',
        source: 'mscience',
        metric: 'digital_revenue',
        align: 'center',
        childWidth: 240,
        childAlign: 'right',
        isNeedSort: true,
      }, {
        title: 'dbi_metric_physical_revenue',
        source: 'npd',
        metric: 'physical_revenue',
        isNeedSort: true,
        align: 'center',
        childWidth: 250,
        childAlign: 'right',
      }],
      games: [{
        title: 'dbi_metric_digitalRevenue',
        source: 'mscience',
        metric: 'digital_revenue',
        align: 'center',
        childWidth: 240,
        childAlign: 'right',
        isNeedSort: true,
      }, {
        title: 'dbi_metric_physical_revenue',
        source: 'npd',
        metric: 'physical_revenue',
        isNeedSort: true,
        align: 'center',
        childWidth: 250,
        childAlign: 'right',
      }, {
        title: 'dbi_metric_mau',
        source: 'newzoo',
        metric: 'mau',
        isNeedSort: true,
        align: 'center',
        childWidth: 170,
        childAlign: 'right',
        // 隐藏的条件,多个条件以;分割
        hideCond: 'dau,wau',
      }, {
        title: 'dbi_metric_dau',
        source: 'newzoo',
        metric: 'dau',
        isNeedSort: true,
        align: 'center',
        childWidth: 170,
        childAlign: 'right',
        // 隐藏的条件,多个条件以;分割
        hideCond: 'mau,wau',
      }, {
        title: 'dbi_metric_wau',
        source: 'newzoo',
        metric: 'wau',
        isNeedSort: true,
        align: 'center',
        childWidth: 170,
        childAlign: 'right',
        // 隐藏的条件,多个条件以;分割
        hideCond: 'mau,dau',
      }],
      countries: [{
        title: 'dbi_metric_digitalRevenue',
        source: 'mscience',
        metric: 'digital_revenue',
        align: 'center',
        childWidth: 240,
        childAlign: 'right',
        isNeedSort: true,
      }, {
        title: 'dbi_metric_physical_revenue',
        source: 'npd',
        metric: 'physical_revenue',
        align: 'center',
        childWidth: 250,
        childAlign: 'right',
        isNeedSort: true,
      }],
      companies:[{
        title: 'dbi_metric_digitalRevenue',
        source: 'mscience',
        metric: 'digital_revenue',
        align: 'center',
        childWidth: 240,
        childAlign: 'right',
        isNeedSort: true,
      }, {
        title: 'dbi_metric_physical_revenue',
        source: 'npd',
        metric: 'physical_revenue',
        align: 'center',
        childWidth: 250,
        childAlign: 'right',
        isNeedSort: true,
      }],
    },
    firstCol: {
      operation: [{
        title: 'dbi_date',
        type: 'date',
        key: 'gametitle',
        hasSort: true,
        defaultSort: true,
        hasCheckbox: false,
        hasRank: false,
        canBeClick: false
      }],
      games: [{
        title: 'dbi_games',
        type: 'gameInfo',
        key: 'gametitle',
        hasSort: false,
        defaultSort: false,
        hasCheckbox: true,
        hasRank: true,
        canBeClick: true,
        width: 360
      }],
      countries: [{
        title: 'dbi_countries',
        type: 'region',
        key: 'gametitle',
        hasSort: false,
        defaultSort: false,
        hasCheckbox: true,
        hasRank: false,
        canBeClick: true
      }],
      companies: [{
        title: 'dbi_company_companies',
        type: 'company',
        key: 'gametitle',
        hasSort: false,
        defaultSort: false,
        hasCheckbox: true,
        hasRank: true,
        canBeClick: true
      }]
    },
    specialCol: {
      operation: null,
      games: [{
        type: 'text',
        title: 'dbi_main_genre',
        key: 'genre',
        width: 200,
        align: 'center',
        childWidth: 140,
        childAlign: 'left',
      }, {
        type: 'text',
        title: 'dbi_sub_genre',
        key: 'sub_genre',
        align: 'center',
        childWidth: 220,
        childAlign: 'left',
      }, {
        type: 'action',
        title: 'dbi_actions',
        key: 'dbi_details',
        linkUrl: '',
        width: 140,
        align: 'center',
        childWidth: 100,
        childAlign: 'left',
      }],
      countries: [{
        type: 'action',
        title: 'dbi_actions',
        key: 'dbi_details',
        linkUrl: '',
        align: 'center',
        childWidth: 100,
        childAlign: 'left',
      }],
      companies: [{
        type: 'action',
        title: 'dbi_actions',
        key: 'dbi_details',
        linkUrl: '',
        align: 'center',
        childWidth: 100,
        childAlign: 'left',
      }]
    },
    tableFormatter: {
      operation: (params: ITableFormatterProp) => _that.common.tableDataFormatter(params),
      games: (params: ITableFormatterProp) => _that.common.tableDataFormatter(params),
      countries: (params: ITableFormatterProp) => _that.common.tableDataFormatter(params),
      companies: (params: ITableFormatterProp) => _that.common.tableDataFormatter(params),
    },
    lineFormatter: {
      operation: (params: ITableFormatterWhenOperaProp) => _that.common.lineChartDataFormatterWhenOpera(params),
      games: (params: ITableFormatterWhenOperaProp) => _that.common.lineChartDataFormatter(params),
      countries: (params: ITableFormatterWhenOperaProp) => _that.common.lineChartDataFormatter(params),
      companies: (params: ITableFormatterWhenOperaProp) => _that.common.lineChartDataFormatter(params),
    },
    keyMap: {
      operation: () => _that.common.keyMap,
      games: () => _that.common.keyMap,
      countries: () => Object.assign({}, _that.common.keyMap, {
        abbr: 'name_abbr'
      }),
      companies: () => _that.common.keyMap,
    },
    regionMetricType: {
      operation: 'digital-revenue',
      games: 'newzoo',
      countries: 'digital-revenue',
      companies: 'digital-revenue',
    }
  },
  console: {
    title: {
      operation: 'dbi_genre_profile_trend',
      games: 'dbi_genre_profile_top_games',
      countries: 'dbi_genre_profile_top_countries',
      companies: 'dbi_genre_profile_top_companies'
    },
    lineTotalText: {
      operation: [{
        label: 'dbi_company_metrics_sum_revenue',
        key: 'sum_revenue'
      }]
    },
    lineMetricList: {
      operation: [{
        label: 'Revenue($)',
        key: 'revenue',
        // 折线图包含几条线，operation维度和其他不一样。
        children: [{
          label: 'dbi_metric_digitalRevenue',
          key: 'digital_revenue'
        }, {
          label: 'dbi_metric_physical_revenue',
          key: 'physical_revenue'
        }]
      }],
      games: [{
        label: 'dbi_metric_digitalRevenue',
        key: 'digital_revenue'
      }, {
        label: 'dbi_metric_physical_revenue',
        key: 'physical_revenue'
      }, {
        label: 'dbi_metric_mau',
        key: 'mau',
        // 隐藏的条件,多个条件以;分割
        hideCond: 'dau,wau',
      }, {
        label: 'dbi_metric_dau',
        key: 'dau',
        // 隐藏的条件,多个条件以;分割
        hideCond: 'mau,wau',
      }, {
        label: 'dbi_metric_wau',
        key: 'wau',
        // 隐藏的条件,多个条件以;分割
        hideCond: 'mau,dau',
      }],
      countries: [{
        label: 'dbi_metric_digitalRevenue',
        key: 'digital_revenue'
      }, {
        label: 'dbi_metric_physical_revenue',
        key: 'physical_revenue'
      }],
      companies: [{
        label: 'dbi_metric_digitalRevenue',
        key: 'digital_revenue'
      }, {
        label: 'dbi_metric_physical_revenue',
        key: 'physical_revenue'
      }],
    },
    tableMetricList: {
      operation: [{
        title: 'dbi_metric_digitalRevenue',
        source: 'mscience',
        metric: 'digital_revenue',
        align: 'center',
        childWidth: 240,
        childAlign: 'right',
        isNeedSort: true,
      }, {
        title: 'dbi_metric_physical_revenue',
        source: 'npd',
        metric: 'physical_revenue',
        align: 'center',
        childWidth: 250,
        childAlign: 'right',
        isNeedSort: true,
      }],
      games: [{
        title: 'dbi_metric_digitalRevenue',
        source: 'mscience',
        metric: 'digital_revenue',
        align: 'center',
        childWidth: 240,
        childAlign: 'right',
        isNeedSort: true,
      }, {
        title: 'dbi_metric_physical_revenue',
        source: 'npd',
        metric: 'physical_revenue',
        align: 'center',
        childWidth: 250,
        childAlign: 'right',
        isNeedSort: true,
      }, {
        title: 'dbi_metric_mau',
        source: 'newzoo',
        metric: 'mau',
        isNeedSort: true,
        align: 'center',
        childWidth: 170,
        childAlign: 'right',
        // 隐藏的条件,多个条件以;分割
        hideCond: 'dau,wau',
      }, {
        title: 'dbi_metric_dau',
        source: 'newzoo',
        metric: 'dau',
        isNeedSort: true,
        align: 'center',
        childWidth: 170,
        childAlign: 'right',
        // 隐藏的条件,多个条件以;分割
        hideCond: 'mau,wau',
      }, {
        title: 'dbi_metric_wau',
        source: 'newzoo',
        metric: 'wau',
        isNeedSort: true,
        align: 'center',
        childWidth: 170,
        childAlign: 'right',
        // 隐藏的条件,多个条件以;分割
        hideCond: 'mau,dau',
      }],
      countries: [{
        title: 'dbi_metric_digitalRevenue',
        source: 'mscience',
        metric: 'digital_revenue',
        align: 'center',
        childWidth: 240,
        childAlign: 'right',
        isNeedSort: true,
      }, {
        title: 'dbi_metric_physical_revenue',
        source: 'npd',
        metric: 'physical_revenue',
        align: 'center',
        childWidth: 250,
        childAlign: 'right',
        isNeedSort: true,
      }],
      companies:[{
        title: 'dbi_metric_digitalRevenue',
        source: 'mscience',
        metric: 'digital_revenue',
        align: 'center',
        childWidth: 240,
        childAlign: 'right',
        isNeedSort: true,
      }, {
        title: 'dbi_metric_physical_revenue',
        source: 'npd',
        metric: 'physical_revenue',
        align: 'center',
        childWidth: 250,
        childAlign: 'right',
        isNeedSort: true,
      }],
    },
    firstCol: {
      operation: [{
        title: 'dbi_date',
        type: 'date',
        key: 'gametitle',
        hasSort: true,
        defaultSort: true,
        hasCheckbox: false,
        hasRank: false,
        canBeClick: false
      }],
      games: [{
        title: 'dbi_games',
        type: 'gameInfo',
        key: 'gametitle',
        hasSort: false,
        defaultSort: false,
        hasCheckbox: true,
        hasRank: true,
        canBeClick: true,
        width: 360
      }],
      countries: [{
        title: 'dbi_countries',
        type: 'region',
        key: 'gametitle',
        hasSort: false,
        defaultSort: false,
        hasCheckbox: true,
        hasRank: false,
        canBeClick: true
      }],
      companies: [{
        title: 'dbi_company_companies',
        type: 'company',
        key: 'gametitle',
        hasSort: false,
        defaultSort: false,
        hasCheckbox: true,
        hasRank: true,
        canBeClick: true
      }]
    },
    specialCol: {
      operation: null,
      games: [{
        type: 'text',
        title: 'dbi_main_genre',
        key: 'genre',
        width: 200,
        align: 'center',
        childWidth: 140,
        childAlign: 'left',
      }, {
        type: 'text',
        title: 'dbi_sub_genre',
        key: 'sub_genre',
        align: 'center',
        childWidth: 220,
        childAlign: 'left',
      }, {
        type: 'action',
        title: 'dbi_actions',
        key: 'dbi_details',
        linkUrl: '',
        width: 140,
        align: 'center',
        childWidth: 100,
        childAlign: 'left',
      }],
      countries: [{
        type: 'action',
        title: 'dbi_actions',
        key: 'dbi_details',
        linkUrl: '',
        align: 'center',
        childWidth: 100,
        childAlign: 'left',
      }],
      companies: [{
        type: 'action',
        title: 'dbi_actions',
        key: 'dbi_details',
        linkUrl: '',
        align: 'center',
        childWidth: 100,
        childAlign: 'left',
      }]
    },
    tableFormatter: {
      operation: (params: ITableFormatterProp) => _that.common.tableDataFormatter(params),
      games: (params: ITableFormatterProp) => _that.common.tableDataFormatter(params),
      countries: (params: ITableFormatterProp) => _that.common.tableDataFormatter(params),
      companies: (params: ITableFormatterProp) => _that.common.tableDataFormatter(params),
    },
    lineFormatter: {
      operation: (params: ITableFormatterWhenOperaProp) => _that.common.lineChartDataFormatterWhenOpera(params),
      games: (params: ITableFormatterWhenOperaProp) => _that.common.lineChartDataFormatter(params),
      countries: (params: ITableFormatterWhenOperaProp) => _that.common.lineChartDataFormatter(params),
      companies: (params: ITableFormatterWhenOperaProp) => _that.common.lineChartDataFormatter(params),
    },
    keyMap: {
      operation: () => _that.common.keyMap,
      games: () => _that.common.keyMap,
      countries: () => Object.assign({}, _that.common.keyMap, {
        abbr: 'name_abbr'
      }),
      companies: () => _that.common.keyMap,
    },
    regionMetricType: {
      operation: 'digital-revenue',
      games: 'newzoo',
      countries: 'digital-revenue',
      companies: 'digital-revenue',
    }
  }
}

const _that = MARKET_DIMENSION_CONFIG;